module.exports = __webpack_public_path__ + "static/media/security.bd8579d7.svg";